module.exports = __webpack_public_path__ + "img/toothpaste-product-original.85931018.jpg";